


















































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { AdditionalModule } from '@/app/store/modules/additionalinfo'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { MasterModule } from '@/app/store/modules/master'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { defaultImage } from '@/utils/default'
@Component({
  components: {
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) public idModal
  @Prop({}) public imageDataCategory
  @Prop({}) public isLoading

  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(2),
  })
  public freeText: string = ''
  @Validate({
    required,
    minLength: minLength(2),
  })
  public freeText2: string = ''
  @Validate({
    required,
    minLength: minLength(2),
  })
  public month: string = ''
  @Validate({
    required,
    minLength: minLength(4),
  })
  public year: string = ''
  @Validate({
    required,
    minLength: minLength(2),
  })
  public dateTimeexpired: string = ''
  @Validate({
    required,
    minLength: minLength(2),
  })

  // Property Input Title
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public title: string = ''

  @Validate({
    required,
  })
  public byPosition3: any = ['All']
  public byPosition5: any = []
  public byPosition2: string = ''
  public byPosition4: string = 'All'
  public byPositionOld: string = ''
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byPosition: string = 'All'

  @Validate({
    required,
  })
  public byGroup3: any = ['All']
  public byGroup2: string = ''
  public byGroup4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byGroup: string = 'All'

  @Validate({
    required,
  })
  public byCity3: any = ['All']
  public byCity2: string = ''
  public byCity4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byCity: string = 'All'

  @Validate({
    required,
  })
  public byDealerCode3: any = ['All']
  public byDealerCode2: string = ''
  public byDealerCode4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byDealerCode: string = 'All'

  @Validate({
    required,
  })
  public byDealerName3: any = ['All']
  public byDealerName2: string = ''
  public byDealerName4: string = 'All'
  @Validate({
    required,
    minLength: minLength(3),
    maxLength: maxLength(255),
  })
  public byDealerName: string = 'All'

  @Validate({
    required,
  })
  public byDealerArea3: any = ['All']
  public byDealerArea2: string = ''
  public byDealerArea: string = 'All'
  public byDealerArea4: string = 'All'

  @Validate({
    required,
  })
  public byTeam3: any = ['All']
  public byTeam2: string = ''
  public byTeam: string = 'All'
  public byTeam4: string = 'All'
  public isDownloadable: boolean = true
  public positions: any = []
  public arr: string[] = []
  public posCount: number = 0
  public groupCount: number = 0
  public cityCount: number = 0
  public codeCount: number = 0
  public nameCount: number = 0
  public teamCount: number = 0
  public areaCount: number = 0
  public max: number = 0
  public sub: number = 0

  public items: any = [
    'All',
    'Salesman',
    'Salesman Counter',
    'Branch Manager',
    'Sales Manager',
    'Supervisor',
  ]

  // has select owner topic
  public ownerTopic: any = [
    {
      position: 'All',
      Group: 'All',
      city: 'All',
      dealercode: 'All',
      dealername: 'All',
      dealerarea: 'All',
      team: 'All',
    },
  ]

  public dealerAreaOptions: any = [
    {
      value: 'All',
      text: 'All',
    },
    {
      value: 'KALIMANTAN & IBT',
      text: 'KALIMANTAN & IBT',
    },
    {
      value: 'JABODETABEK',
      text: 'JABODETABEK',
    },
    {
      value: 'WEST JAVA',
      text: 'WEST JAVA',
    },
    {
      value: 'CENTRAL JAVA',
      text: 'CENTRAL JAVA',
    },
    {
      value: 'EAST JAVA',
      text: 'EAST JAVA',
    },
    {
      value: 'SUMATERA',
      text: 'SUMATERA',
    },
  ]

  public teamOptions: any = [
    {
      value: 'All',
      text: 'All',
    },
    {
      value: 'PC',
      text: 'PC',
    },
    {
      value: 'LCV',
      text: 'LCV',
    },
  ]

  public onRemovePosition(data) {
    const index = this.byPosition3.indexOf(data)
    // console.log('data yang diremove' + data + ' ' + index)
    this.byPosition3.splice(index, 1)
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
    this.byPosition4 = this.byPosition
    if (this.byPosition3.length === 0) {
      this.byPosition3.push('All')
      this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
      this.byPosition4 = this.byPosition
      this.byPosition2 = ''
    }
  }
  public onRemoveGroup(data) {
    const index = this.byGroup3.indexOf(data)
    this.byGroup3.splice(index, 1)
    this.byGroup = this.byGroup3.join(',').replace(/\s/g, '')
    this.byGroup4 = this.byGroup
    if (this.byGroup3.length === 0) {
      this.byGroup3.push('All')
      this.byGroup = this.byGroup3.join(',').replace(/\s/g, '')
      this.byGroup4 = this.byGroup
      this.byGroup2 = ''
    }
  }
  public onRemoveDelerCode(data) {
    const index = this.byDealerCode3.indexOf(data)
    this.byDealerCode3.splice(index, 1)
    this.byDealerCode = this.byDealerCode3.join(',').replace(/\s/g, '')
    this.byDealerCode4 = this.byDealerCode
    if (this.byDealerCode3.length === 0) {
      this.byDealerCode3.push('All')
      this.byDealerCode = this.byDealerCode3.join(',').replace(/\s/g, '')
      this.byDealerCode4 = this.byDealerCode
      this.byDealerCode2 = ''
    }
  }
  public onRemoveDelerName(data) {
    const index = this.byDealerName3.indexOf(data)
    this.byDealerName3.splice(index, 1)
    this.byDealerName = this.byDealerName3.join(';').replace(/\s/g, '')
    this.byDealerName4 = this.byDealerName
    if (this.byDealerName3.length === 0) {
      this.byDealerName3.push('All')
      this.byDealerName = this.byDealerName3.join(';').replace(/\s/g, '')
      this.byDealerName4 = this.byDealerName
      this.byDealerName2 = ''
    }
  }
  public onRemoveDelerArea(data) {
    const index = this.byDealerArea3.indexOf(data)
    this.byDealerArea3.splice(index, 1)
    this.byDealerArea = this.byDealerArea3.join(',').replace(/\s/g, '')
    this.byDealerArea4 = this.byDealerArea
    if (this.byDealerArea3.length === 0) {
      this.byDealerArea3.push('All')
      this.byDealerArea = this.byDealerArea3.join(',').replace(/\s/g, '')
      this.byDealerArea4 = this.byDealerArea
      this.byDealerArea2 = ''
    }
  }
  public onRemoveCity(data) {
    const index = this.byCity3.indexOf(data)
    this.byCity3.splice(index, 1)
    this.byCity = this.byCity3.join(',').replace(/\s/g, '')
    this.byCity4 = this.byCity
    if (this.byCity3.length === 0) {
      this.byCity3.push('All')
      this.byCity = this.byCity3.join(',').replace(/\s/g, '')
      this.byCity4 = this.byCity
      this.byCity2 = ''
    }
  }
  public onRemoveTeam(data) {
    const index = this.byTeam3.indexOf(data)
    this.byTeam3.splice(index, 1)
    this.byTeam = this.byTeam3.join(',').replace(/\s/g, '')
    this.byTeam4 = this.byTeam
    if (this.byTeam3.length === 0) {
      this.byTeam3.push('All')
      this.byTeam = this.byTeam3.join(',').replace(/\s/g, '')
      this.byTeam4 = this.byTeam
      this.byTeam2 = ''
    }
  }
  // public onOptionClickPosition(data) {
  //   this.byPosition3.push(data);
  //   this.byPosition = this.byPosition3.join(",").replace(/\s/g, "");
  //   this.byPosition4 = this.byPosition;
  //   this.byPosition2 = "";
  // }
  public onOptionClickGroup(data) {
    this.byGroup3.push(data)
    const index = this.byGroup3.indexOf('All')
    if (index === 0) {
      this.byGroup3.splice(index, 1)
    }
    this.byGroup = this.byGroup3.join(',').replace(/\s/g, '')
    this.byGroup4 = this.byGroup
    this.byGroup2 = ''
  }
  public onOptionClickCode(data) {
    this.byDealerCode3.push(data)
    const index = this.byDealerCode3.indexOf('All')
    if (index === 0) {
      this.byDealerCode3.splice(index, 1)
    }
    this.byDealerCode = this.byDealerCode3.join(',').replace(/\s/g, '')
    this.byDealerCode4 = this.byDealerCode
    this.byDealerCode2 = ''
  }

  public onOptionClickName(data) {
    this.byDealerName3.push(data)
    const index = this.byDealerName3.indexOf('All')
    if (index === 0) {
      this.byDealerName3.splice(index, 1)
    }
    this.byDealerName = this.byDealerName3.join(';').replace(/\s/g, '')
    this.byDealerName4 = this.byDealerName
    this.byDealerName2 = ''
  }
  public onOptionClickArea(data) {
    this.byDealerArea3.push(data)
    const index = this.byDealerArea3.indexOf('All')
    if (index === 0) {
      this.byDealerArea3.splice(index, 1)
    }
    this.byDealerArea = this.byDealerArea3.join(',').replace(/\s/g, '')
    this.byDealerArea4 = this.byDealerArea
    this.byDealerArea2 = ''
  }
  public onOptionClickCity(data) {
    this.byCity3.push(data)
    const index = this.byCity3.indexOf('All')
    if (index === 0) {
      this.byCity3.splice(index, 1)
    }
    this.byCity = this.byCity3.join(',').replace(/\s/g, '')
    this.byCity4 = this.byCity
    this.byCity2 = ''
  }
  public onOptionClickTeam(data) {
    this.byTeam3.push(data)
    const index = this.byTeam3.indexOf('All')
    if (index === 0) {
      this.byTeam3.splice(index, 1)
    }
    this.byTeam = this.byTeam3.join(',').replace(/\s/g, '')
    this.byTeam4 = this.byTeam
    this.byTeam2 = ''
  }

  // validate input sales-code
  // Using @@keypress="freeText1Press($event)" in html
  // public freeText1Press(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (this.freeText1.length > 4) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }
  // public freeText2Press(evt) {
  //   evt = evt ? evt : window.event
  //   const charCode = evt.which ? evt.which : evt.keyCode
  //   if (this.freeText1.length > 4) {
  //     evt.preventDefault()
  //   } else {
  //     return true
  //   }
  // }
  public monthPress(evt) {
    evt = evt ? evt : window.event
    const charCode = evt.which ? evt.which : evt.keyCode
    if (
      this.month.length > 1 ||
      (charCode > 31 && (charCode < 48 || charCode > 57))
    ) {
      evt.preventDefault()
    } else {
      return true
    }
  }
  public yearPress(evt) {
    evt = evt ? evt : window.event
    const charCode = evt.which ? evt.which : evt.keyCode
    if (
      this.year.length > 3 ||
      (charCode > 31 && (charCode < 48 || charCode > 57))
    ) {
      evt.preventDefault()
    } else {
      return true
    }
  }
  // Property Select Status
  public isActive: boolean = true
  public optionsIsActive: any = [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false },
  ]

  // Property Select Recomended
  public isRecommended: boolean = true
  public optionsIsRecommended: any = [
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ]

  public onPaste(evt) {
    return evt.preventDefault()
  }
  public disableDate(date) {
    return date < new Date()
  }

  @Watch('byPosition3')
  public onPosition3Changed(value: string, oldValue: string) {
    // console.log('Data dari old' + oldValue)
    this.byPositionOld = oldValue
    // console.log('Data dari posisi' + this.byPositionOld)
    if (this.byPositionOld.toString() === 'All') {
      const index = this.byPosition3.indexOf('All')
      this.byPosition3.splice(index, 1)
      // console.log('data masuk splice' + index)
    }
    this.byPosition = this.byPosition3.join(',').replace(/\s/g, '')
    this.byPosition4 = this.byPosition
    // console.log('data masuk sesuadah di bersihni' + this.byPosition3)
    if (this.byPosition === '') {
      this.byPosition3 = ['All']
    }
    // this.byPosition2 = "";
  }
  @Watch('byCity2')
  public onCity2Changed(value: string, oldValue: string) {
    this.byCity = this.byCity2
  }

  @Watch('byCity')
  public onCityChanged(text) {
    if (text.length >= 3 && text !== 'All') {
      MasterModule.paginationParam.search = text
      MasterModule.getCity()
    }
  }
  public cities: any = []
  public get cityData() {
    this.cities = MasterModule.MasterData.data
    return MasterModule.MasterData
  }

  @Watch('byGroup2')
  public onDealerGroup2Changed(value: string, oldValue: string) {
    this.byGroup = this.byGroup2
  }
  @Watch('byGroup')
  public onDealerGroupChanged(text) {
    if (text.length >= 3 && text !== 'All') {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerGroup()
    }
  }

  public dealerGroup: any = []
  public get dealerGroupData() {
    this.dealerGroup = MasterModule.DealerGroupData.data
    return MasterModule.DealerGroupData
  }
  @Watch('byDealerCode2')
  public byDealerCode2Changed(value: string, oldValue: string) {
    this.byDealerCode = this.byDealerCode2
  }
  @Watch('byDealerCode')
  public byDealerCodeChanged(text) {
    if (text.length >= 3 && text !== 'All') {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
  }
  public dealerCodeOptions: any = []

  public get dealerCode() {
    this.dealerCodeOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }
  @Watch('byDealerName2')
  public byDealerName2Changed(value: string, oldValue: string) {
    this.byDealerName = this.byDealerName2
  }

  @Watch('byDealerName')
  public byDealerNameChanged(text) {
    if (text.length >= 3) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerName()
    }
  }
  public dealerNameOptions: any = []
  public get dealerNameCode() {
    this.dealerNameOptions = MasterModule.DealerNameData.data
    return MasterModule.DealerNameData
  }
  // // validate input sales-code
  // // @keypress="freeTextPress($event)" if you want imlement in html
  public freeTextPress(evt) {
    evt = evt ? evt : window.event
    const charCode = evt.which ? evt.which : evt.keyCode
    if (this.freeText.length > 4) {
      evt.preventDefault()
    } else {
      return true
    }
  }

  // Property Base64
  public hasFiles = {
    fileName: '',
    fileByte: '',
  }
  @Validate({
    required,
  })
  public fileUpload: any = null
  public get stateFile() {
    return Boolean(this.fileUpload)
  }
  public base64Pdf(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles.fileName = input.files[0].name
        this.hasFiles.fileByte = hash.length ? hash[1] : ''
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }
  public get ownerId(): any {
    let ix1 = 0
    let ix2 = 0
    let ix3 = 0
    let ix4 = 0
    let ix5 = 0
    let ix6 = 0
    let ix7 = 0
    const p = 0
    let variabel = ''
    this.posCount = this.byPosition4.toString().split(',').length
    this.groupCount = this.byGroup.toString().split(',').length
    this.cityCount = this.byCity.toString().split(',').length
    this.areaCount = this.byDealerArea.toString().split(',').length
    this.codeCount = this.byDealerCode.toString().split(',').length
    this.teamCount = this.byTeam.toString().split(',').length
    this.nameCount = this.byDealerName.toString().split(';').length
    this.max = Math.max(
      this.posCount,
      this.groupCount,
      this.cityCount,
      this.areaCount,
      this.codeCount,
      this.teamCount,
      this.nameCount
    )
    for (ix1 = 0; ix1 < this.posCount; ix1++) {
      for (ix2 = 0; ix2 < this.groupCount; ix2++) {
        for (ix3 = 0; ix3 < this.cityCount; ix3++) {
          for (ix4 = 0; ix4 < this.codeCount; ix4++) {
            for (ix5 = 0; ix5 < this.nameCount; ix5++) {
              for (ix6 = 0; ix6 < this.areaCount; ix6++) {
                for (ix7 = 0; ix7 < this.teamCount; ix7++) {
                  ;(variabel =
                    this.byPosition4
                      .toString()
                      .split(',')
                      [ix1].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byGroup4
                      .toString()
                      .split(',')
                      [ix2].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byCity4
                      .toString()
                      .split(',')
                      [ix3].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byDealerCode4
                      .toString()
                      .split(',')
                      [ix4].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byDealerName4
                      .toString()
                      .split(';')
                      [ix5].toLowerCase()
                      .replace(/[^a-z0-9]/gi, '')
                      .split(' ')
                      .join('')
                      .split(',')
                      .join('') +
                    '-' +
                    this.byDealerArea4
                      .toString()
                      .split(',')
                      [ix6].toLowerCase()
                      .split(' ')
                      .join('') +
                    '-' +
                    this.byTeam4
                      .toString()
                      .split(',')
                      [ix7].toLowerCase()),
                    this.arr.push(variabel)
                }
              }
            }
          }
        }
      }
    }
    return this.arr
  }

  public resetAdd() {
    this.byPosition = 'All'
    this.byPosition4 = 'All'
    this.byPosition3 = ['All']
    this.$v.title.$reset()
    this.$v.freeText.$reset()
    this.$v.month.$reset()
    this.$v.year.$reset()
    this.$v.fileUpload.$reset()
    // this.freeText1 = "";
    this.$v.byGroup2 = ''
    this.dateTimeexpired = ''
    this.byPosition = 'All'
    this.byGroup = 'All'
    this.byCity = 'All'
    this.byTeam = 'All'
    this.byDealerCode = 'All'
    this.byDealerName = 'All'
    this.byDealerArea = 'All'
    this.byPosition4 = 'All'
    this.byGroup4 = 'All'
    this.byCity4 = 'All'
    this.byTeam4 = 'All'
    this.byDealerCode4 = 'All'
    this.byDealerName4 = 'All'
    this.byDealerArea4 = 'All'
    this.byCity2 = ''
    this.byGroup2 = ''
    this.byPosition2 = ''
    this.byDealerCode2 = ''
    this.byDealerName2 = ''
    this.dateTimeexpired = ''
    this.isActive = true
    this.isRecommended = true
    this.stateCoverImage = false
    this.stateThumbnailImage = false
    this.cancelImageThumbnailId()
    this.stateActive = false
    this.stateRecommended = false
    this.stateExpiredDate = false
    this.arr = []
    this.max = 0
    this.dealerGroup = []
    this.dealerNameOptions = []
    this.dealerCodeOptions = []
    this.cities = []
    this.byCity3 = ['All']
    this.byPosition3 = ['All']
    this.byGroup3 = ['All']
    this.byDealerCode3 = ['All']
    this.byDealerName3 = ['All']
    this.byDealerArea3 = ['All']
    this.byTeam3 = ['All']
    this.fileUpload = null
    this.hasFiles = {
      fileName: '',
      fileByte: '',
    }

    this.imageThumbnailId = {
      id: null,
      link: defaultImage,
    }
  }

  public changeImageThumbnailId(item) {
    this.stateThumbnailImage = false
    this.imageThumbnailId.id = item.id
    this.imageThumbnailId.link = item.link
  }
  public cancelImageThumbnailId() {
    this.stateThumbnailImage = true
    this.imageThumbnailId.id = null
    this.imageThumbnailId.link = defaultImage
  }
  public stateCoverImage = false
  public stateThumbnailImage = false
  public stateLogoImage = false
  public stateActive = false
  public stateRecommended = false
  public stateExpiredDate = false
  // Property Post Data
  public postNotif(item, index, button) {
    this.$v.freeText.$touch()
    this.$v.month.$touch()
    this.$v.year.$touch()
    this.$v.title.$touch()
    this.$v.fileUpload.$touch()
    if (
      this.$v.title.$invalid ||
      this.$v.freeText.$invalid ||
      this.$v.month.$invalid ||
      this.$v.year.$invalid ||
      this.imageThumbnailId.id === null ||
      !this.stateFile
    ) {
      this.imageThumbnailId.id === null
        ? (this.stateThumbnailImage = true)
        : (this.stateThumbnailImage = false)
      this.stateActive = true
      this.stateRecommended = true
      this.isDownloadable = true
      // this.stateExpiredDate = true;
    } else {
      if (this.$v.dateTimeexpired.$invalid) {
        this.dateTimeexpired = 'automatic'
      }
      // console.log('Kapan expied' + this.dateTimeexpired)
      const dataToPost = {
        title: this.title,
        fileCode: this.freeText + '-' + this.month + '-' + this.year,
        imageThumbnailId: this.imageThumbnailId.id,
        isActive: this.isActive,
        isRecommended: this.isRecommended,
        fileName: this.hasFiles.fileName,
        fileByte: this.hasFiles.fileByte,
        fileUpload: this.fileUpload,
        expireddate: this.dateTimeexpired,
        ownerId: this.ownerId,
        isDownloadable: this.isDownloadable,
      }
      AdditionalModule.postAdditional(dataToPost)
      this.$root.$emit('bv::hide::modal', this.idModal, button)
    }
  }
}
